export const getAddAccountText = state => state.usersReducer.texts.addAccount
export const getAddAccountTooltipText = state => state.usersReducer.texts.addAccountTooltip
export const getPlayText = state => state.usersReducer.texts.play
export const getPlayTooltipText = state => state.usersReducer.texts.playTooltip
export const getPinTooltipText = state => state.usersReducer.texts.pinTooltip
export const getUnPinTooltipText = state => state.usersReducer.texts.unPinTooltip
export const getStartTooltipText = state => state.usersReducer.texts.startTooltip
export const getStopTooltipText = state => state.usersReducer.texts.stopTooltip
export const getProfileTooltipText = state => state.usersReducer.texts.profileTooltip
export const getLogOutTooltipText = state => state.usersReducer.texts.logOutTooltip
export const getErrorAutoRefreshText = state => state.usersReducer.texts.errorAutoRefresh
export const getErrorRefreshingText = state => state.usersReducer.texts.errorRefreshing



// WEBPACK FOOTER //
// ./src/features/Users/data/texts/selectors.js